import whatsappBg from "../../../../../assets/subscriptions/WaLM.png"
import {RootState, useAppSelector} from "../../../../../state/state.tsx";


export default function WhatsappChatBubble({message,WhatsappImagePreview,imageTemplates,template}: { message: string, WhatsappImagePreview:string,imageTemplates:any,template:string }) {

    function refactorTextToWhatsappFormat(text:string){
        let formattedText = text.replace(/\n/g, '<br />');

        // Replace *bold* with <strong>bold</strong>
        formattedText = formattedText.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');

        // Replace _italic_ with <em>italic</em>
        formattedText = formattedText.replace(/_([^_]+)_/g, '<em>$1</em>');

        formattedText = formattedText.replace(/~([^~]+)~/g, '<del>$1</del>');

        formattedText = formattedText.replace(/^- (.*)$/gm, '<li>$1</li>')
        // formattedText = formattedText.replace(/(<li>.*<\/li>)/g, '<ul>$1</ul>');

        return formattedText;
    }


    const ServiceProviderName = useAppSelector((state:RootState)=>state.userSlice.display_name);
    const BusinessName  = useAppSelector((state:RootState)=>state.userSlice.businessProfile.businessName)


    return (

        <div className="flex h-auto min-h-[300px] rounded-lg items-start gap-2.5 bg-black p-4"
             style={{backgroundImage: `url(${whatsappBg})`, backgroundSize: "cover"}}>

            <div className="flex flex-col gap-1 w-full max-w-[350px] text-gray-900">
                <div className="flex items-center space-x-2 rtl:space-x-reverse">
                    <span className="text-sm font-semibold ">{ServiceProviderName}</span>

                </div>
                <div
                    className="flex flex-col gap-2 leading-1.5 p-4 border-gray-200  rounded-e-xl rounded-es-xl  bg-gray-100 relative pb-8">
                      <img
                        src={WhatsappImagePreview || imageTemplates[template]}
                        className="rounded-lg"/>


                    <p className="text-sm  font-semibold text-gray-900"> Hello from {BusinessName}!</p>
                    <p className="text-sm font-normal "> {`Hi {Customer name}`},</p>

                    <div className={"text-wrap"} dangerouslySetInnerHTML={{__html: refactorTextToWhatsappFormat(message)}}/>

                    <span><p className="text-sm font-normal "> Best regards</p>
                    <p className="text-sm font-normal ">{ServiceProviderName}</p></span>

                    <span className="text-xs font-normal text-gray-500 absolute right-2 bottom-2">11:46 pm</span>
                </div>
                <span className="text-sm font-normal text-gray-500">Delivered</span>
            </div>


        </div>


    )


}